import { useEffect, useState } from 'react';
import { i18n } from '@/i18n-config';
import { storage_keys } from '@/constant/configs';
import { languages, LanguageType } from '@/constant/localeData';
import Cookies from 'js-cookie';
import { useUserStore } from '@/stores/restuarant/user';
import { de, enUS } from 'date-fns/locale';

type Default = {
  lang: LanguageType | null;
};

const initialValues = {
  lang: null,
};

const useLanguageChange = () => {
  const [defaultLocale, setDefaultLocale] = useState<Default>(initialValues);

  const resUser = useUserStore((state) => state.user);
  const resProfile = resUser?.related_restaurant;
  let localeCode = '';

  if (defaultLocale?.lang?.key && resProfile?.country?.alpha_2) {
    localeCode = `${defaultLocale?.lang?.key}-${resProfile?.country?.alpha_2}`;
  }

  const langMap = {
    de: de,
    en: enUS,
  };

  let localeObj: any;

  if (defaultLocale?.lang?.key) {
    localeObj = defaultLocale?.lang?.key == 'de' ? langMap.de : langMap.en;
  }

  const setLang = (lang: string) => {
    Cookies.set(storage_keys.restaurant_lang, lang, {
      expires: 60,
    });
  };

  useEffect(() => {
    let currentLanCode = Cookies.get(storage_keys.restaurant_lang);
    if (!currentLanCode) {
      currentLanCode = i18n.defaultLanguage;
      setLang(currentLanCode);
    }

    let resLang;
    if (!defaultLocale.lang) {
      resLang = languages.find(
        (item: LanguageType) => item.key === currentLanCode
      );
    }

    setDefaultLocale({
      lang: resLang ?? null,
    });
  }, []);

  const changeLanguage = (lang: string) => {
    Cookies.remove(storage_keys.restaurant_lang);
    const langData = languages.find((item: LanguageType) => item.key === lang);
    if (langData) {
      setLang(lang);
      setDefaultLocale({
        ...defaultLocale,
        lang: langData,
      });
      window.location.reload();
    }
  };

  return { changeLanguage, defaultLocale, localeCode, localeObj };
};

export default useLanguageChange;
